import { Box, Text } from '@jfs/ui-new'

const AddUpdateGroup = () => {
  return (
    <Box padding={24}>
      <Text>Screen AddUpdateGroup</Text>
    </Box>
  )
}

export default AddUpdateGroup
